import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-detail",
  "use": "ico-detail-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" id=\"ico-detail\">\n  <path id=\"ico-detail_Path_1873\" data-name=\"Path 1873\" d=\"M12,24A12,12,0,1,0,0,12,12,12,0,0,0,12,24Zm-1.875-8.25H11.25v-3H10.125a1.125,1.125,0,0,1,0-2.25h2.25A1.122,1.122,0,0,1,13.5,11.625V15.75h.375a1.125,1.125,0,0,1,0,2.25h-3.75a1.125,1.125,0,0,1,0-2.25ZM12,6a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12,6Z\" transform=\"translate(0.5 0.5)\" fill=\"none\" stroke=\"#5393d0\" stroke-width=\"1\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol